<script>

  export default {
    name: "FeaturesSectionBox",
    props: {
      data: {
        type: Object,
      },
      index: {
        type: Number,
      }
    },
  };
</script>


<template>
  <article class="row gy-2">
    <div class="text-box col-60 col-lg-34 pb-lg-2" :class="index % 2 === 0 ? 'order-lg-2' : 'order-lg-1' ">
      <h2 class="text-primary fw-semibold mb-1" v-html="data.name">
      </h2>
      <h2 class="fw-semibold mb-1 fs-smaller" v-html="data.slogan">
      </h2>
      <p v-html="data.description">
      </p>
    </div>
    <div class="col-60 col-lg-26 text-center" :class="index % 2 === 0 ? 'order-lg-1' : 'order-lg-2' ">
      <img
          :src="data.image.slug"
          :class="[data.image.class_override ? data.image.class_override : 'mb-3']"
          :style="data.image.style_override"
      />
    </div>
  </article>
</template>


<style lang="scss" scoped>
  article {
    background: linear-gradient(180deg, #FCFCFC 0%, #FFFFFF 100%);
    border-radius: 1rem;
    padding: 1rem 1rem 0 1rem;
    margin: auto auto 0.75rem auto;
  };

  img {
    width: 100%;
  };

  .text-box {
    padding: 0 1.5rem 0 1.5rem;
    margin-top: 2.5rem;
  };
</style>